// deno-fmt-ignore-file
import { Array } from '../../types/array.mjs';
import { AddImmutable } from '../../action/_add_immutable.mjs';
export function FromArray(type) {
    const result = AddImmutable(Array(type));
    return result;
}
